import AdvantagesSection from "../components/AdvantagesSection";
import ChartSection from "../components/ChartSection";
import Header from "../components/Header";
import FaqsSection from "../components/FaqsSection";
import Contact from "../components/Contact";
import AnticipateSection from "../components/AniticipateSection";
import Footer from "../components/Footer";
import Responsibility from "../components/Responsibility";
import { useState } from "react";

function App() {
  const [language, setLanguage] = useState("de");

  return (
    <>
      <Header language={language} setLanguage={setLanguage} />
      <ChartSection />
      <AdvantagesSection />
      <Responsibility />
      <FaqsSection />
      <Contact />
      <AnticipateSection language={language} />
      <Footer />
    </>
  );
}

export default App;
